import { put, takeLatest } from "redux-saga/effects";
import { call } from "typed-redux-saga";
import _ from "lodash";
import {
  getProfileRecommendationsFailed,
  getProfileRecommendationsRequest,
  getProfileRecommendationsSuccess,
} from "../reducers/profileRecommendations/profileRecommendations.reducer";
import recommendationsServices from "../services/profileRecommendations.services";

interface payloadInterface {
  type: String;
  payload: any;
}

// Profile Recommendations Worker
function* getProfileRecommendationsWorker({ payload }: payloadInterface) {
  const userId =
    typeof payload === "object" && payload !== null
      ? (payload.userId ?? payload.user_id ?? payload)
      : payload;
  const params =
    typeof payload === "object" && payload !== null
      ? {
          page: payload.page,
          pageSize: payload.pageSize,
        }
      : undefined;

  const response = yield* call(
    recommendationsServices.getProfileRecommendations,
    userId,
    params,
  );
  try {
    if (response.flag === true) {
      yield put(getProfileRecommendationsSuccess({ data: response }));
    } else {
      yield put(
        getProfileRecommendationsFailed({
          message: _.get(response, "message", ""),
          errors: _.get(response, "errors", {}),
        }),
      );
    }
  } catch (error) {
    yield put(
      getProfileRecommendationsFailed({ message: _.get(error, "message", "") }),
    );
  }
}

export function* getProfileRecommendationsWatcher() {
  yield takeLatest(
    getProfileRecommendationsRequest,
    getProfileRecommendationsWorker,
  );
}
